module.exports = __webpack_public_path__ + "img/plovdiv.cc2f3f61.jpg";